module.exports = __webpack_public_path__ + "static/media/filter-gray.5aafd1d3.svg";